// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDmj_saO36uEoRPIWDpcgMVEf424WQncKU",
  authDomain: "borondala-official.firebaseapp.com",
  projectId: "borondala-official",
  storageBucket: "borondala-official.appspot.com",
  messagingSenderId: "33254663694",
  appId: "1:33254663694:web:f4ef46256752f69d51be5f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
